module.exports = __webpack_public_path__ + "img/weather32.e7041c5d.png";